import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'health_professional',
    name: 'health-professional',
    component: Form,
    redirect: { name: 'health-professional-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'health-professional-list',
        component: () =>
          import('@/views/healthProfessional/HealthProfessionalList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('healthProfessional.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'health-professional-create',
        component: () =>
          import('@/views/healthProfessional/HealthProfessionalCreate.vue'),
        meta: {
          header: {
            route: { name: 'health-professional-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('healthProfessional.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id(\\d+)',
        name: 'health-professional-edit',
        component: () =>
          import('@/views/healthProfessional/HealthProfessionalEdit.vue'),
        meta: {
          header: {
            route: { name: 'health-professional-list' },
            label: () =>
              i18n.t('title.edit', [i18n.tc('healthProfessional.label', 2)]),
          },
        },
      },
      {
        path: 'view/:id',
        name: 'health-professional-view',
        component: () =>
          import('@/views/healthProfessional/HealthProfessionalView.vue'),
        meta: {
          header: {
            route: { name: 'health-professional-list' },
            label: () =>
              i18n.t('title.view', [i18n.tc('healthProfessional.label', 1)]),
          },
        },
      },
    ],
  },
];

export default routes;
